import React from 'react';
import { AvForm } from 'availity-reactstrap-validation';
import { Col, Row } from 'reactstrap';
import OrderService from "../../shared/service/OrderService";
import GeneralUtils from "../../shared/utils/GeneralUtils";

export default class OrdersDisplay extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            orderListPreparing: [],
            orderListReady: [],
            currentPagePreparing: 0,
            currentPageReady: 0,
            pageSize: 10
        };
        this.orderService = new OrderService();
    }

    componentDidMount() {
        this.refreshOrderList();
        this.setupPagingIntervals();
    }

    componentWillUnmount() {
        clearInterval(this.refreshInterval);
        clearInterval(this.pageIntervalPreparing);
        clearInterval(this.pageIntervalReady);
    }

    refreshOrderList() {
        this.getOrderList();
        this.refreshInterval = setInterval(() => {
            this.getOrderList();
        }, 5000);
    }

    getOrderList(){
        this.orderService.displayOrders("ORDER_PREPARING").then(response => {
            if ( GeneralUtils.isNullOrEmpty(response.type)) {
                this.setState({ orderListPreparing: response });
            }
        });

        this.orderService.displayOrders("ORDER_READY").then(response => {
            if ( GeneralUtils.isNullOrEmpty(response.type)) {
                this.setState({ orderListReady: response });
            }
        });
    }

    setupPagingIntervals() {
        //otomatik sayfa gecisi
        this.pageIntervalPreparing = setInterval(() => {
            const totalPages = Math.ceil(this.state.orderListPreparing.length / this.state.pageSize);
            this.setState(prev => ({
                currentPagePreparing: (prev.currentPagePreparing + 1) % (totalPages || 1)
            }));
        }, 5000);

        this.pageIntervalReady = setInterval(() => {
            const totalPages = Math.ceil(this.state.orderListReady.length / this.state.pageSize);
            this.setState(prev => ({
                currentPageReady: (prev.currentPageReady + 1) % (totalPages || 1)
            }));
        }, 5000);
    }

    renderOrders(list, currentPage, color, background) {
        const start = currentPage * this.state.pageSize;
        const visibleOrders = list.slice(start, start + this.state.pageSize);

        const orderBoxStyle = {
            fontSize: '2rem',
            borderRadius: '10px',
            border: `3px solid ${color}`,
            height: '100px',
            fontWeight: 'bold',
            backgroundColor: background,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            textAlign: 'center',
            color: color
        };

        return (
            <div className="p-grid">
                {visibleOrders.map((order, index) => (
                    <div key={index} className="p-col-6" style={{ marginBottom: '1rem' }}>
                        <div style={orderBoxStyle}>
                            {order.orderNo}
                        </div>
                    </div>
                ))}
            </div>
        );
    }

    render() {
        const {
            orderListPreparing,
            orderListReady,
            currentPagePreparing,
            currentPageReady
        } = this.state;

        const titleContainerStyle = {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '100%',
            marginBottom: '1rem'
        };

        const baseLineStyle = {
            flex: 1,
            height: '1px',
            margin: '0 0.5rem'
        };

        const titleTextStyle = {
            fontSize: '1.2rem',
            fontWeight: 'bold',
            whiteSpace: 'nowrap'
        };

        const columnStyle = {
            padding: '1rem',
            width: '48%',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start'
        };

        const listContainerStyle = {
            width: '100%'
        };

        return (
            <div style={{ padding: '2rem' }}>
                <AvForm>
                    <Row style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                        {/* Preparing Orders */}
                        <div style={columnStyle}>
                            <div style={titleContainerStyle}>
                                <div style={{ ...baseLineStyle, backgroundColor: '#1982D9' }}></div>
                                <div style={{ ...titleTextStyle, color: '#1982D9' }}>Preparing Orders</div>
                                <div style={{ ...baseLineStyle, backgroundColor: '#1982D9' }}></div>
                            </div>
                            <div style={listContainerStyle}>
                                {this.renderOrders(orderListPreparing, currentPagePreparing, '#1982D9', '#eaf4fc')}
                            </div>
                        </div>

                        {/* Ready Orders */}
                        <div style={columnStyle}>
                            <div style={titleContainerStyle}>
                                <div style={{ ...baseLineStyle, backgroundColor: '#28a745' }}></div>
                                <div style={{ ...titleTextStyle, color: '#28a745' }}>Ready Orders</div>
                                <div style={{ ...baseLineStyle, backgroundColor: '#28a745' }}></div>
                            </div>
                            <div style={listContainerStyle}>
                                {this.renderOrders(orderListReady, currentPageReady, '#28a745', '#e6f9ec')}
                            </div>
                        </div>
                    </Row>
                </AvForm>
            </div>
        );
    }
}
